
import React, { useState, useEffect } from "react";

import { Row, Col, Button } from "react-bootstrap";
import "./SessionMain.css";
import  SessionMainTable from "./SessionMainTable.js";
import InformationTabContainer from "./InformationTabContainer";
import BootstrapTable from "react-bootstrap-table-next";
import  "./LargeSpinner.css";
import convertMSE from "../Components/Utils/convertMSE";
import aws_exports from "../aws-exports";
import Amplify, { API } from "aws-amplify";


Amplify.configure(aws_exports, {});

 /*
var MainObject = {

TotalBiomass:-1,
TotalAverageWeight:-1,
Lasting:-1,
DateTime:-1.0,
Companyname:"",
Nocommentlines:-1,
//logoimage=
ChannelC_Version:"",
pdfFilePath:"",
pdfFile:"",
NrCountingUnits:-1,
  CountingUnits:[]
};


blcFilePath: "",
   cntFilePath: "",
   mseFilePath: "",
   blcFile:"",
   cntFile:"",
   mseFile:"",
   Name: "",
  ID: -1,
  FileName:"",
  SizeSetting: "",
  Count:-1,
  Percent_Count:-1,
  Biomass:-1,
  Percent_Biomass:-1,
  Counter_type:"",
  Average_weight:""


  */

 var mseFetchingIndex = 0;

 var mseDetailData = {};


  export default function CounterDetails(props) {

 

  const [tableData, setTableData] = useState([]);

  const [loadingMse, setLoadingMse] = useState(false);
  const [mseLoaded, setMseLoaded] = useState(false);  

  



  useEffect(() => {


    


  
 











  
  
    setLoadingMse(false);
    setMseLoaded (false);
    




  }, [props]);



  















//const SessionMain = props => (


const MseDetailsNotify = (idx) => {


    let len = props.Data.NrCountingUnits;
    let tmp = [];
    for (let i = 0; i<len; i++){
        tmp.push({...tableData[i], key:i})
    }
    tmp [idx]. activeButton = false;
    setTableData(tmp);

};


const getMseFile = async (s3Path, urls) => {




//    s3Path = s3Path.replace("999999/", "3153/")
 





    let apiName = "vakicloudRdsAPI";
    let path =  "/getFile"; 
    let myInit = {
      // OPTIONAL
      headers: {}, // OPTIONAL
      response: false, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: {
        // OPTIONAL
          S3Path: s3Path
      }
    };




    API.get(apiName, path, myInit).then(resp => {
    //  let str  =  resp.success.toUpperCase();
   


    
        let data = convertMSE(resp.success);


        mseDetailData = {
          mainData:null,
          informationRowData: data,
          newDataLoaded: true,
          newDataLoading: false,
          blcFileURL: "xxxxxxx", //props.Data.CountingUnits[mseFetchingIndex].blcFileUrl,
          cntFileURL: "xxxxxxxxxx",//props.Data.CountingUnits[mseFetchingIndex].cntFile,
          mseFileURL: "xxxx",//props.Data.CountingUnits[mseFetchingIndex].mseFileUrl,
          pdfFileURL: null,
          mseS3Path: props.Path+".mse",
          pdfFilePath: null,
          blcFilePath: props.Path+".blc",
          cntFilePath: props.Path+".cnt",
          key:0
        };
       
            setLoadingMse(false);
            setMseLoaded (true);
        
      



    }).  catch (err =>{
      console.log ("Error when fetching msefile ("+mseFetchingIndex+") : "+err)

    });
   
  };


const  callGetMseFile = async (idx) =>
{

    getMseFile (props.Data.CountingUnits[idx].mseFilePath);
}  





const handleShowMseClick = () => {
  
    setLoadingMse (true);


    getMseFile( props.Path+".mse", {}  );
}


const scrollToBottom = () => {
    let fakeD = document.getElementById("fakeDiv");
    fakeD.scrollIntoView({ behavior: "smooth" });
  };


var MseArea = "";

if (loadingMse){

    MseArea = <div className="spinner-wrap">  <div className="loader"></div> </div>

} else if (!mseLoaded){

    MseArea=     <Button variant="outline-secondary" type="Button" block name = "getmse"  onClick = {handleShowMseClick}  >
    {"Fetch "+props.CounterName+" details"}
    </Button>;
    
}else {
 
    MseArea = [];




        MseArea = (
     <div className = "unit-wrap">       
        <h4> {props.CounterName }</h4>
    <InformationTabContainer

 
    data= {mseDetailData.informationRowData}
    blcFileURL = {null}
//cntFileURL: props.Data.CountingUnits[mseFetchingIndex].cntFile,
    mseFileURL = {null}
    pdfFileURL={null}
    mseS3Path = {props.Path+".mse"}
    pdfFilePath={null}
    blcFilePath = {props.Path+".BLC"}
    cntFilePath= {props.Path+".cnt"}
    scrollToBottom= {null} //{scrollToBottom}
        />
        </div>
        );

 
    //display details
}






    return(
  <div>
   
    <div id="mse-wrap">
        
        {MseArea}
    </div>
  </div>
);
};

